/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import * as types from "../../types/primitives.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * Request body for preview_equipment_browser_view.
 */
export type PreviewEquipmentBrowserViewRequestBody = {
  /**
   * Display template to preview
   */
  displayTemplate: string;
  /**
   * The id of the equipment browser view. If not specified, the default view will be returned.
   */
  viewId?: string | undefined;
};

/** @internal */
export const PreviewEquipmentBrowserViewRequestBody$inboundSchema: z.ZodType<
  PreviewEquipmentBrowserViewRequestBody,
  z.ZodTypeDef,
  unknown
> = z.object({
  display_template: types.string(),
  view_id: types.optional(types.string()),
}).transform((v) => {
  return remap$(v, {
    "display_template": "displayTemplate",
    "view_id": "viewId",
  });
});
/** @internal */
export type PreviewEquipmentBrowserViewRequestBody$Outbound = {
  display_template: string;
  view_id?: string | undefined;
};

/** @internal */
export const PreviewEquipmentBrowserViewRequestBody$outboundSchema: z.ZodType<
  PreviewEquipmentBrowserViewRequestBody$Outbound,
  z.ZodTypeDef,
  PreviewEquipmentBrowserViewRequestBody
> = z.object({
  displayTemplate: z.string(),
  viewId: z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    displayTemplate: "display_template",
    viewId: "view_id",
  });
});

export function previewEquipmentBrowserViewRequestBodyToJSON(
  previewEquipmentBrowserViewRequestBody:
    PreviewEquipmentBrowserViewRequestBody,
): string {
  return JSON.stringify(
    PreviewEquipmentBrowserViewRequestBody$outboundSchema.parse(
      previewEquipmentBrowserViewRequestBody,
    ),
  );
}
export function previewEquipmentBrowserViewRequestBodyFromJSON(
  jsonString: string,
): SafeParseResult<PreviewEquipmentBrowserViewRequestBody, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) =>
      PreviewEquipmentBrowserViewRequestBody$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'PreviewEquipmentBrowserViewRequestBody' from JSON`,
  );
}
